(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cm-mobile-purchase')) {
    customElements.define('cm-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.scope = document.getElementById(`MainProduct-${this.dataset.section}`);
        this.source = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        if (!this.scope || !this.source) return;
        this.action = this.querySelector('button');
        this.action.addEventListener('click', () => {
          if (!this.source.disabled) this.source.click();
        });
        this.sync = () => {
          this.source = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
          if (!this.source) { this.hidden = true; return; }
          this.action.textContent = this.source.querySelector('span')?.textContent.trim() || this.source.textContent.trim();
          this.action.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
          const price = this.scope.querySelector('[id^="price-"] .price');
          const selector = price?.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
          this.querySelector('.cm-mobile-purchase__price').textContent = price?.querySelector(selector)?.textContent.trim() || '';
        };
        this.sync();
        this.changes = new MutationObserver(this.sync);
        this.changes.observe(this.scope, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
        this.visibility = new IntersectionObserver(entries => { this.hidden = entries[0].isIntersecting; });
        this.visibility.observe(this.source);
      }
      disconnectedCallback() { this.changes?.disconnect(); this.visibility?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
